import strings from 'strings';

const { sequences: sequencesCopies } = strings.bulkEmails.forms;

export const getStepsDrawerFinalTitle = ({ shouldEdit, shouldShowPreview }) => {
  if (shouldShowPreview) {
    return shouldEdit
      ? sequencesCopies.editStep.previewTitle
      : sequencesCopies.addSteps.previewTitle;
  }

  return shouldEdit ? sequencesCopies.editStep.title : sequencesCopies.addSteps.title;
};
